var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"text-align":"center"}},[_c('el-carousel',{attrs:{"trigger":"click","height":"120px","direction":"vertical","autoplay":false}},_vm._l((_vm.items),function(url,index){return _c('el-carousel-item',{key:index},[_c('el-avatar',{attrs:{"shape":"circle","size":100,"fit":"fill","src":url}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }